import React, { useState } from 'react'
import { getBackgroundColor, getFormatedWeb3Address, formatSmartDecimal } from '../../utils/helpers'
import { useTheme } from '../../contexts/ThemeProvider'
import { DARK_THEME, MARKET_V3, RESOLVER } from '../../utils/constants'
import DisputeTimer from './DisputeTimerUi';
import { Modal } from 'react-bootstrap'
import { userSmartAccount } from '../RecoilAtom'
import { useRecoilValue } from 'recoil'
import { useSwipeClose } from '../../hooks/useSwipeClose';

const MarketOutcomeMobile = ({ winnerData, poolsdetail, setShowEvidence, setShowEvidenceHistory, timeExtendUi, extendDisputeTimer, publicPoolResolverAddress, disputeTimer, setDisputeTimer, reSubmitOrFinalizeSpinner, revealWinner, revealWinnerUi, showresubmit, setShowResubmit, handleEstimateReSubmitAppealGas, poolUnderDisputeUi, poolDisputed, isAppealed, oracleExtendedTimeNo, gasEstimateInUsdt, gasFeesSpinner, handleEstimateFinalizeWinnerGas, hasTooEarlyHistory }) => {
    const { theme } = useTheme()
    const smartAccount = useRecoilValue(userSmartAccount);
    const decidedByResolver = poolsdetail?.winnerOption?.decidedBy === RESOLVER
    const [finalizeMode, setFinalizeMode] = useState(false);
    const isCurrentUserAppealer = poolsdetail?.appealData?.senderWalletAddress?.toLowerCase() === smartAccount?.toLowerCase();

    const handleConfirmAction = async () => {
        if (finalizeMode) {
            await revealWinner();
        } else {
            await extendDisputeTimer();
        }
    };

    const winnerDotColor = getBackgroundColor(
        poolsdetail?.options?.findIndex(opt => opt._id === winnerData?.winnerId),
        theme,
        poolsdetail?.options?.length
    );

    const decidedByImg = theme === DARK_THEME
        ? <img src="\assets\olympus-outcomedark.svg" alt="img" className="img-fluid" />
        : <img src="\assets\olympus-outcome.svg" alt="img" className="img-fluid" />;

    const swipeRef = useSwipeClose(showresubmit, () => setShowResubmit(false));

    return (
        <>
            <div className="proposed-outcome-flow-mobile">
                {
                    !hasTooEarlyHistory ? <div className="upper-field">
                        <div className="inside-left">
                            <p>Proposed Outcome</p>
                            <h6>
                                <span className="dot-color" style={{ backgroundColor: winnerDotColor }}></span>
                                {winnerData?.winnerOption}
                            </h6>
                        </div>
                        {poolsdetail?.version >= MARKET_V3 && (
                            <>
                                <div className="outcome-decided">
                                    <p>Decided By</p>
                                    {decidedByResolver ? (
                                        <div className="specific-participant">
                                            <img src={poolsdetail?.winnerProposer?.user?.profilePic} alt="img" className="img-fluid" style={{ width: "18px", height: "18px", borderRadius: "50%" }} />
                                            <h6>
                                                {poolsdetail?.winnerProposer?.user?.name || getFormatedWeb3Address(poolsdetail?.winnerProposer?.user?.walletAddress, true)}
                                                <span>{poolsdetail?.winnerProposer?.role}</span>
                                            </h6>
                                        </div>
                                    ) : (
                                        decidedByImg
                                    )}
                                </div>
                            </>
                        )}
                    </div> : <div className="too-early-case-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <g clipPath="url(#clip0_3917_8023)">
                                <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke="#797979" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9 12V9" stroke="#797979" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9 6H9.0075" stroke="#797979" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_3917_8023">
                                    <rect width="18" height="18" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <p>The last resolution attempt was submitted too early. The market remains open and available for resolution.</p>
                    </div>
                }


                {poolUnderDisputeUi && !timeExtendUi && poolDisputed && isAppealed && (
                    <div className="raised-dispute">
                        <div className="upper-text">
                            <h6>{isCurrentUserAppealer ? 'Your appeal is under review.' : 'An Appeal has been submitted'}</h6>
                            <p>Appeal Review by {decidedByImg}</p>
                        </div>
                        <div className="lower-text">
                            <p>Appeal Resolution In</p>
                            <DisputeTimer
                                disputeTimer={disputeTimer}
                                setDisputeTimer={setDisputeTimer}
                            />
                        </div>
                    </div>
                )}
                {timeExtendUi && poolDisputed && isAppealed && (
                    <div className="raised-dispute review-delayed">
                        <div className="upper-text">
                            <h6>Human Review Delayed</h6>
                            <p>Ethos did not return a decision within the expected time.</p>
                            <span>Resubmission attempt {oracleExtendedTimeNo ?? 0} of 7</span>
                        </div>
                        <button
                            className="btn-resubmit-appeal"
                            onClick={() => { setFinalizeMode(false); handleEstimateReSubmitAppealGas(); }}
                            disabled={!smartAccount}
                        >
                            Resubmit Appeal
                        </button>
                    </div>
                )}
                {revealWinnerUi && (
                    <div className="raised-dispute review-delayed review-completed">
                        <div className="upper-text">
                            <h6>Human Review Completed</h6>
                            <p>Ethos has returned a final decision for this market.</p>
                            <span>Finalizing will publish the decision on-chain and close the market. This action requires a network gas fee.</span>
                        </div>
                        <button
                            className="btn-resubmit-appeal"
                            onClick={() => { setFinalizeMode(true); handleEstimateFinalizeWinnerGas(); }}
                        >
                            Finalize Decision
                        </button>
                    </div>
                )}

                <div className="bottom-field">
                    <button className="btn-history-mbl" onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M7.99967 14.6666C11.6816 14.6666 14.6663 11.6818 14.6663 7.99992C14.6663 4.31802 11.6816 1.33325 7.99967 1.33325C4.31778 1.33325 1.33301 4.31802 1.33301 7.99992C1.33301 11.6818 4.31778 14.6666 7.99967 14.6666Z" stroke="#757575" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M8 4V8L10.6667 9.33333" stroke="#757575" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <p>History</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
                            <path d="M0.296477 1.71L2.88648 4.3C3.27648 4.69 3.90648 4.69 4.29648 4.3L6.88648 1.71C7.51648 1.08 7.06648 0 6.17648 0L0.996477 0C0.106477 0 -0.333523 1.08 0.296477 1.71Z" fill="#757575" />
                        </svg>
                    </button>
                </div>
            </div>

            <Modal
                className="detail privatepollmodal dispute-create-modal resubmit-appeal-modal new-modal-style"
                show={showresubmit}
                onHide={() => setShowResubmit(false)}
                centered
                backdrop="static"
                animation={false}
            >
                <Modal.Header ref={swipeRef}>
                    <div className="close-div d-none" ></div>
                </Modal.Header>
                <Modal.Body>
                    <div className="dispute-create-parent">
                        <div className="upper-icon icongrey">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                <path d="M31.5 22.8765C32.2667 21.8842 32.7419 20.6979 32.8722 19.4507C33.0025 18.2034 32.7827 16.9445 32.2376 15.8152C31.6925 14.6858 30.8435 13.7307 29.7859 13.0568C28.7283 12.3829 27.5039 12.017 26.25 12H23.565C23.1377 10.5738 22.412 9.25472 21.436 8.13036C20.46 7.00599 19.2561 6.10205 17.9041 5.4785C16.5521 4.85496 15.0829 4.52607 13.5941 4.51367C12.1053 4.50127 10.6309 4.80563 9.26866 5.40657C7.90645 6.00751 6.68762 6.89127 5.69304 7.99922C4.69846 9.10717 3.95088 10.414 3.49991 11.8329C3.04893 13.2518 2.90488 14.7504 3.0773 16.2293C3.24972 17.7081 3.73468 19.1334 4.49999 20.4105" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.5 16.5V22.5H16.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 28.5C12.9445 29.7593 14.2612 30.6895 15.7637 31.1589C17.2663 31.6282 18.8784 31.6129 20.3717 31.1151C21.865 30.6173 23.1639 29.6623 24.0843 28.3853C25.0047 27.1083 25.5 25.5741 25.5 24C25.5 22.2098 24.7888 20.4929 23.523 19.227C22.2571 17.9612 20.5402 17.25 18.75 17.25C17.8003 17.2493 16.8597 17.4357 15.9821 17.7986C15.1044 18.1615 14.3069 18.6938 13.635 19.365L10.5 22.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <h4>{finalizeMode ? 'Finalize Market Resolution?' : 'Resubmit Appeal?'}</h4>
                        <p className="para">
                            {finalizeMode ? (
                                <>Ethos has returned a final decision.<br />By continuing, the result will be published on-chain and the market will move to Final Resolution.</>
                            ) : (
                                <>The human review process did not return a decision in time.<br />By continuing, the appeal will be submitted again to Ethos.</>
                            )}
                            <br /><br />This action requires a network gas fee.
                        </p>
                        <div className="outcomes-parent">
                            <div className="single">
                                <div className="bottom p-0">
                                    <p>network fee:</p>
                                    <h6>
                                        {gasFeesSpinner
                                            ? <span className="spinner" />
                                            : `$${formatSmartDecimal(gasEstimateInUsdt) || '—'}`
                                        }
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="twice-btns">
                            <button className="btn-cancel" onClick={() => setShowResubmit(false)}>Cancel</button>
                            <button
                                className="btn-dispute"
                                disabled={gasFeesSpinner || reSubmitOrFinalizeSpinner}
                                onClick={handleConfirmAction}
                            >
                                {(gasFeesSpinner || reSubmitOrFinalizeSpinner) ? 'Loading...' : finalizeMode ? 'Confirm & Finalize' : 'Confirm & Pay Gas'}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default MarketOutcomeMobile
